import { useEffect } from 'react';

interface SEOHeadProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  ogType?: string;
  schemaData?: Record<string, unknown>[];
}

export default function SEOHead({
  title,
  description,
  keywords,
  canonicalUrl,
  ogType = 'website',
  schemaData = [],
}: SEOHeadProps) {
  useEffect(() => {
    document.title = `${title} - 福利社导航`;

    const setMeta = (property: string, content: string) => {
      let el = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.querySelector(`meta[name="${property}"]`) as HTMLMetaElement | null;
      }
      if (el) {
        el.setAttribute('content', content);
      }
    };

    setMeta('og:title', `${title} - 福利社导航`);
    setMeta('og:description', description);
    setMeta('og:type', ogType);
    if (canonicalUrl) {
      setMeta('og:url', canonicalUrl);
    }
    setMeta('twitter:title', `${title} - 福利社导航`);
    setMeta('twitter:description', description);

    if (keywords) {
      const metaKeywords = document.querySelector('meta[name="keywords"]');
      if (metaKeywords) {
        metaKeywords.setAttribute('content', keywords);
      }
    }

    // Handle Schema.org JSON-LD
    schemaData.forEach((schema, index) => {
      const scriptId = `schema-ld-${index}`;
      let scriptEl = document.getElementById(scriptId);
      if (!scriptEl) {
        scriptEl = document.createElement('script');
        scriptEl.id = scriptId;
        scriptEl.setAttribute('type', 'application/ld+json');
        document.head.appendChild(scriptEl);
      }
      scriptEl.textContent = JSON.stringify(schema);
    });

    return () => {
      // Cleanup schema scripts
      schemaData.forEach((_, index) => {
        const scriptEl = document.getElementById(`schema-ld-${index}`);
        if (scriptEl) {
          document.head.removeChild(scriptEl);
        }
      });
    };
  }, [title, description, keywords, canonicalUrl, ogType, schemaData]);

  return null;
}